import React from 'react';
import Appointments from '../components/appointments/Appointments';

const AppointmentPage = () => {
    return (
        <div>
            <Appointments />
        </div>
    );
};

export default AppointmentPage;
